export function buildCreateOptions(props, allProps, converterMap) {
  var options = {};
  var getSetterValue = function getSetterValue(key, props) {
    if (key in converterMap) {
      return converterMap[key](props[key]);
    }
    return props[key];
  };
  allProps.forEach(function (key) {
    if (key in props) {
      if (key !== 'visible') {
        options[key] = getSetterValue(key, props);
      }
    }
  });
  return options;
}